import res from './res'

res.add('ru', {
    noDataLable: 'Мәлімет жоқ'
})
